<template>
    <div class="collapse-info-box collapse-info-box-disabled">
        <div v-if="isEdit" v-watermark>
            <van-field name="effectFlag" label="疗程评价" placeholder="请填写随访总结">
                <template #input>
                    <van-radio-group v-model="addEditData.effectFlag" direction="horizontal">
                        <van-radio :name="item.key" icon-size="14px" v-for="item in evaluateRadioList" :key="item.key">
                            {{ item.value }}
                        </van-radio>
                    </van-radio-group>
                </template>
            </van-field>
            <van-field class="border-box" v-model="addEditData.followSummary" name="followSummary" :maxlength="200"
                label="随访总结" placeholder="请填写随访总结" type="textarea">
            </van-field>
            <van-field label="随访状态">
                <template #input>
                    <vSelect :options="arrangeList" :reduce="(item) => item.key" label="value" :clearable="false"
                        placeholder="请选择" v-model="addEditData.followStatus">
                        <template #open-indicator="{ attributes }">
                            <span v-bind="attributes">
                                <van-icon name="play" class="icon-box" />
                            </span>
                        </template>
                        <template #no-options>无匹配数据</template>
                    </vSelect>
                </template>
            </van-field>
            <van-field label="三因图片是否好转">
                <template #input>
                    <van-radio-group v-model="addEditData.tcBetterFlag" direction="horizontal">
                        <van-radio :name="item.key" icon-size="14px" v-for="item in improveList" :key="item.key">
                            {{ item.value }}
                        </van-radio>
                    </van-radio-group>
                </template>
            </van-field>
            <van-field label="是否遵医嘱">
                <template #input>
                    <div style="width:25vw">
                        <vSelect :options="medicalAdvice" :reduce="(item) => item.key" label="value" :clearable="false"
                            placeholder="请选择" v-model="addEditData.abideAdviceStatus">
                            <template #open-indicator="{ attributes }">
                                <span v-bind="attributes">
                                    <van-icon name="play" class="icon-box" />
                                </span>
                            </template>
                            <template #no-options>无匹配数据</template>
                        </vSelect>
                    </div>
                </template>
            </van-field>
            <van-field class="border-box" v-model="addEditData.affectTmReason" name="affectTmReason" :maxlength="200"
                label="影响服药原因" placeholder="请填写影响服药原因" type="textarea">
            </van-field>
        </div>
        <div class="form-info-box" v-else v-watermark>
            <div class="form-item">
                <div class="form-lable">疗程评价</div>
                <div class="form-title">
                    {{ findName(therapeuticEvaluation.effectFlag, 1) }}
                </div>
            </div>
            <div class="form-item">
                <div class="form-lable">随访总结</div>
                <div class="form-title">
                    {{ therapeuticEvaluation.followSummary }}
                </div>
            </div>
            <div class="form-item">
                <div class="form-lable">随访状态</div>
                <div class="form-title">
                    {{ findName(therapeuticEvaluation.followStatus, 2) }}
                </div>
            </div>
            <div class="form-item">
                <div class="form-lable">三因图片是否好转</div>
                <div class="form-title">
                    {{ findName(therapeuticEvaluation.tcBetterFlag, 3) }}
                </div>
            </div>
            <div class="form-item">
                <div class="form-lable">是否遵医嘱</div>
                <div class="form-title">
                    {{ findName(therapeuticEvaluation.abideAdviceStatus, 4) }}
                </div>
            </div>
            <div class="form-item">
                <div class="form-lable">影响服药原因</div>
                <div class="form-title">
                    {{ therapeuticEvaluation.affectTmReason || "-" }}
                </div>
            </div>
        </div>
        <TableForm :type="1" :list="tableAllData.tableList1" v-if="tableAllData.tableList1.length > 0"
            :isEdit="isEdit" />
        <TableForm :type="4" :list="tableAllData.tableList4" v-if="tableAllData.tableList4.length > 0"
            :isEdit="isEdit" />
        <TableForm :type="2" :list="tableAllData.tableList2" v-if="tableAllData.tableList2.length > 0"
            :isEdit="isEdit" />
        <div class="save-box van-hairline--top">
            <template v-if="isEdit">
                <van-button type="default" @click="cancel">取消</van-button>
                <van-button type="primary" color="#0082EF" @click="save">确定</van-button>
            </template>
            <template v-else>
                <van-button type="primary" color="#0082EF" @click="isEdit = true">编辑</van-button>
            </template>
        </div>
        <BaseDddInfo :type="1" :data-list="tabAllData.tabList1" :treatment-id="therapeuticEvaluation.id" />
        <BaseDddInfo :type="2" :data-list="tabAllData.tabList2" :treatment-id="therapeuticEvaluation.id" />
        <BaseDddInfo :type="3" :data-list="tabAllData.tabList3" :treatment-id="therapeuticEvaluation.id" />
        <BaseDddInfo :type="4" :data-list="tabAllData.tabList4" :treatment-id="therapeuticEvaluation.id" />
    </div>
</template>
<script>
import TableForm from "./tableForm.vue";
import BaseDddInfo from "./baseDddInfo.vue";
import { formatNum } from "@/utils/baseFormat";
import { upDateTherapeuticEvaluation } from "@/api/moreEffective";
export default {
    name: "collapseInfo",
    props: {
        therapeuticEvaluation: {
            type: Object,
            default: () => { },
        },
    },
    components: {
        TableForm,
        BaseDddInfo,
    },
    inject: ["updataTherapeuticEvaluationData"], // 更新方法
    data() {
        return {
            addEditData: {},
            isEdit: false,
            // tabData
            tabAllData: {
                tabList1: [],
                tabList2: [],
                tabList3: [],
                tabList4: [],
            },
            // 表格数据  1病种 2症状 4西医诊断
            tableAllData: {
                tableList1: [],
                tableList2: [],
                tableList4: [],
            },
        };
    },
    computed: {
        evaluateRadioList() {
            return [
                { key: 1, value: "有效" },
                { key: 3, value: "无效" },
                { key: 2, value: "待观察" },
            ];
        },
        arrangeList() {
            return [
                { key: 1, value: "未反馈" },
                { key: 2, value: "正常随访" },
                { key: 3, value: "停止服药(已康复)" },
                { key: 4, value: "服药中断(疫情中断)" },
                { key: 5, value: "服药中断(服用其他药物参与/其他治疗药物)" },
                { key: 6, value: "服药中断(身体不适)" },
            ];
        },
        improveList() {
            return [
                { key: 1, value: "是" },
                { key: 0, value: "否" },
            ];
        },
        medicalAdvice() {
            return [
                { key: 1, value: "偶尔漏服" },
                { key: 2, value: "经常漏服" },
                { key: 3, value: "偶尔吃药" },
                { key: 4, value: "严格服药" },
                { key: 5, value: "未服药" },
                { key: 6, value: "选择性服药" },
                { key: 7, value: "未反馈" },
            ];
        },
    },
    watch: {
        therapeuticEvaluation: {
            handler(value) {
                if (value) {
                    this.setData(value);
                    this.tabAllData = {
                        tabList1: [],
                        tabList2: [],
                        tabList3: [],
                        tabList4: [],
                    };
                    JSON.parse(JSON.stringify(value.treatmentSymptoms || [])).forEach(
                        (item) => {
                            if (item.type === 4 || item.type === 5) {
                                this.tabAllData["tabList4"].push(item);
                            } else {
                                this.tabAllData[`tabList${item.type}`].push(item);
                            }
                        }
                    );
                }
            },
            deep: true,
            immediate: true,
        },
    },
    methods: {
        setData(value) {
            this.tableAllData = {
                tableList1: [],
                tableList2: [],
                tableList4: [],
            };
            // 处理集合
            this.addEditData = JSON.parse(
                JSON.stringify({
                    ...value,
                    evalVos: "",
                    treatmentSymptoms: "",
                })
            );
            // 排序 无 《  是 《 否
            const formatSortParams = (num) => {
                // console.log(num)
                // typeof num !== 'number' ? -1 : num === 0 ? 1 : 0

                return {
                    0: 0,
                    1: 1,
                    null: 3,
                }[num];
            };
            const sortData = JSON.parse(JSON.stringify(value.evalVos || [])).sort(
                (a, b) => {
                    return (
                        formatSortParams(b.trackStatus) - formatSortParams(a.trackStatus)
                    );
                }
            );
            sortData.forEach((item) => {
                this.tableAllData[`tableList${item.type}`].push(item);
            });
        },
        async save() {
            // 更新
            const params = {
                ...this.addEditData,
                evals: Object.values(this.tableAllData).flat() || null,
            };
            try {
                await upDateTherapeuticEvaluation(params);
                this.updataTherapeuticEvaluationData();
            } catch (error) {
                console.log(error);
            }
            this.isEdit = false;
        },
        cancel() {
            this.setData(this.therapeuticEvaluation);
            this.isEdit = false;
        },
        formatTitle(index) {
            return `第${formatNum(this.listData.length - index)}疗程`;
        },
        findName(value, type) {
            const obj = {
                1: "evaluateRadioList",
                2: "arrangeList",
                3: "improveList",
                4: "medicalAdvice",
            };
            let findObj = this[obj[type]].find((item) => item.key === value);
            return findObj ? findObj.value : "-";
        },
    },
};
</script>
<style lang="scss" scoped>
:deep(.v-select) {
    width: 100% !important;
}

.collapse-info-box {
    .van-field,
    .van-cell {
        background-color: transparent;
    }
    .van-cell {
        overflow: visible;
        padding: 9px 15px;

        &::after {
            display: none;
        }

        .van-field__label {
            font-size: 14px;
            color: #666666;
            width: auto;
        }
    }

    :deep(.border-box) {
        .van-field__body {
            overflow: hidden;
            padding: 5px 10px;
            border-radius: 4px;
            border: 1px solid #e1e8ef;

            textarea {
                font-size: 14px;
            }
        }
    }

    .van-radio {
        .van-radio__label {
            font-size: 14px;
            color: #888888;
            margin-left: 5px;
        }

        .van-radio__icon--checked {
            .van-icon {
                border: 1px solid #4991fc;
                background-color: #fff;
                position: relative;

                &::before {
                    position: absolute;
                    content: "";
                    left: 50%;
                    top: 50%;
                    width: 75%;
                    height: 75%;
                    border-radius: 50%;
                    background: #4991fc;
                    transform: translate(-50%, -50%);
                }
            }
        }
    }

    .save-box {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 15px;

        .van-button {
            font-size: 14px;
            border-radius: 4px;
            padding: 6px 20px;
            width: auto;
            height: auto;

            &+.van-button {
                margin-left: 30px;
            }
        }
    }

    .form-info-box {
        .form-item {
            padding: 9px 15px;
            display: flex;
            align-items: flex-start;

            .form-lable {
                padding-right: 14px;
                color: #666666;
                font-size: 14px;
            }

            .form-title {
                flex: 1;
                font-size: 14px;
                color: #333333;
                white-space: pre-wrap;
                word-break: break-all;
            }
        }
    }
}
</style>
